import ListItemBody2 from 'components/ListItem';

import styles from './styles.module.scss';

const ProfileListItems = ({ className, manageAccount, handleLogout }) => (
    <ul className={`${className} ${styles.option}`}>
        <ListItemBody2
            className={styles.manageAccount}
            onClick={manageAccount}
            text="Manage Profile"
        />

        <ListItemBody2
            className={styles.signOut}
            onClick={handleLogout}
            text="Sign Out"
        />
    </ul>
);

export default ProfileListItems;
